export default class JobseekerPersonalDetailsTemp {
    constructor(
        public dob_day ?: string,
        public dob_month ?: string,
        public dob_year ?: string,
        public gender  ?: string,
        public permanent_address  ?: string,
        public home_town  ?: string,
        public pin_code  ?: string,
        public marital_status  ?: string,
        public category ?: string,
        public differently_abled  ?: string,
        public differently_abled_type  ?: string,
        public assistance_for_workplace  ?: string,
        public work_permit  ?: string,
        public jobseeker_id?: number,
        public provider?: string,
        public state?: string,
        public ethnicity?: string
    ){

    }
}